export interface LiffIdEnvironment {
  readonly VITE_LIFF_ID?: string;
  readonly VITE_LIFF_ID_REVIEW?: string;
}

/** URL のパスに対応する LIFF ID を選ぶ。環境やブラウザ状態には依存しない。 */
export function selectLiffId(
  pathname: string,
  env: LiffIdEnvironment,
): string | undefined {
  const reviewPath = pathname === '/review' || pathname.startsWith('/review/');
  if (reviewPath && env.VITE_LIFF_ID_REVIEW !== undefined
    && env.VITE_LIFF_ID_REVIEW.length > 0) {
    return env.VITE_LIFF_ID_REVIEW;
  }
  return env.VITE_LIFF_ID;
}
